import { Editor } from 'ngx-editor';
import { Schema } from 'prosemirror-model';
import { nodes as ngxNodes, marks as ngxMarks } from 'ngx-editor/schema';

// Allow only http/https/mailto for link marks. Blocks javascript:, data:, vbscript:.
export const SAFE_LINK_PATTERN = '^(https?://|mailto:).+';

// Block-level + inline nodes we trust. Excludes `image` (no inline images from
// user-typed content) and keeps the rest of ngx-editor's defaults.
const allowedNodeKeys = [
  'doc',
  'text',
  'paragraph',
  'blockquote',
  'horizontal_rule',
  'heading',
  'hard_break',
  'code_block',
  'list_item',
  'ordered_list',
  'bullet_list',
] as const;

// Text marks we trust. Excludes `text_color` and `text_background_color` to
// remove arbitrary style attributes that complicate sanitization.
const allowedMarkKeys = ['em', 'strong', 'code', 'u', 's', 'sup', 'sub', 'link'] as const;

function pick<T extends Record<string, unknown>>(source: T, keys: readonly string[]): Record<string, T[keyof T]> {
  const result: Record<string, T[keyof T]> = {};
  for (const key of keys) {
    if (key in source) {
      result[key] = source[key] as T[keyof T];
    }
  }
  return result;
}

const restrictedSchema = new Schema({
  nodes: pick(ngxNodes as unknown as Record<string, unknown>, allowedNodeKeys) as any,
  marks: pick(ngxMarks as unknown as Record<string, unknown>, allowedMarkKeys) as any,
});

export function createSafeEditor(): Editor {
  return new Editor({
    schema: restrictedSchema,
    linkValidationPattern: SAFE_LINK_PATTERN,
  });
}
